import pick from 'lodash/pick'
import { Args } from 'src/__generated__/globalTypes'
import {
  useEffect,
  usePersistedState,
  usePersistedUserData,
  useSelector,
} from '.'

type QueryParams = Args & {
  join?: true | undefined
  sponsor?: string | undefined
  isJoiningAffiliate?: true | undefined
  isJoiningPromo?: true | undefined
  promoPlanId?: string
  payment?: true | undefined
  client?: string
  shoppingCartCategory?: string | undefined
  shoppingCartProduct?: string | undefined
  isNewJoiningAffiliateFlow?: boolean
  postcardPromo?: boolean
}

const useQueryParams = (): QueryParams => {
  const { account } = usePersistedUserData()
  const args = useSelector(state => state.route.args)
  const [persistedArgs, setPersistedArgs] = usePersistedState<
    typeof args | undefined
  >('persisted-query-params', undefined)

  useEffect(
    () =>
      persistedArgs &&
      setPersistedArgs({ ...persistedArgs, ...pick(args, ['sponsor']) }),
    [setPersistedArgs, persistedArgs, args],
  )

  return {
    ...args,
    join: 'join' in args ? true : undefined,
    isJoiningAffiliate: 'affiliatejoin' in args ? true : undefined,
    isJoiningPromo: 'promo' in args ? true : undefined,
    promoPlanId: 'promo' in args ? args.promo : undefined,
    sponsor: account ? undefined : args.sponsor ?? persistedArgs?.sponsor,
    payment: 'payment' in args ? true : undefined,
    postcardPromo: 'postcardPromo' in args,
    shoppingCartCategory:
      'shoppingcartcategory' in args ? args.shoppingcartcategory : undefined,
    shoppingCartProduct:
      'shoppingcartproduct' in args ? args.shoppingcartproduct : undefined,
    isNewJoiningAffiliateFlow:
      'affiliatejoin' in args &&
      ('shoppingcartproduct' in args || 'shoppingcartcategory' in args),
  }
}

export default useQueryParams
